import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useOrdersMain() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  
const changeAdminOrderStatus = async (payload) => {
  try {
    const res = await api.post(
      "/Admin/orders/changeOrderStatus",
      payload
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage || "Status updated",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Status update failed",
      };
    }
  } catch (e) {
    console.error(
      "changeOrderStatus error:",
      e
    );
    return {
      success: false,
      message:
        "Something went wrong",
    };
  }
};
const getOrderEvents = async (orderId) => {
  try {
    const { data } = await api.post("/Order/v1.0/getOrderEvents", {
      orderId: String(orderId || ""),
    });

    if (data?.responseCode === "00") {
      return data.response || [];
    }

    return [];
  } catch (error) {
    console.error("getOrderEvents error:", error);
    return [];
  }
};
const changeCatalogOrderStatus = async ({
  userid,
  orderid,
  status,
}) => {
  try {
    const requestBody = {
      userid,
      orderid,
      productid: "",
      status,
      time: "",
      payment: "",
    };

    const res = await api.post(
      "/Whatsapp/changeCatelogOrderStatus",
      requestBody
    );

    if (res?.data?.responseCode === "00" || !res?.data?.responseCode) {
      return {
        success: true,
        message: `Order updated → ${status}`,
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to update status",
      };
    }
  } catch (e) {
    console.error("changeCatalogOrderStatus error:", e);

    return {
      success: false,
      message: "Failed to update status",
    };
  }
};
const assignDoorDashOrder = async ({ orderId, userId, adminId }) => {
  try {
    const requestBody = {
      orderId,
      userid: userId || "",
      adminId: adminId ? String(adminId) : undefined,
    };

    const response = await api.post(
      "/Whatsapp/changeCatelogOrderStatus",
      requestBody
    );

    const data = response?.data;

    if (data?.responseCode === "00") {
      return {
        success: true,
        data,
        message: data?.responseMessage || "DoorDash assigned successfully",
      };
    }

    return {
      success: false,
      data,
      message:
        data?.responseMessage || "Failed to assign DoorDash",
    };
  } catch (error) {
    console.error("DoorDash assign error:", error);

    return {
      success: false,
      error: true,
      message: "Something went wrong while assigning DoorDash.",
    };
  }
};
const notifyDriver = async (payload) => {
  try {
    const response = await api.post(
      "/Delivery/v1.0/notifyDriver",
      payload
    );

    const data = response?.data;

    if (data?.responseCode === "00") {
      return {
        success: true,
        message: data?.responseMessage || "Driver notified successfully",
        data,
      };
    }

    return {
      success: false,
      message:
        data?.responseMessage ||
        "Failed to update delivery partner status.",
    };
  } catch (error) {
    console.error("notifyDriver error:", error);

    return {
      success: false,
      message: "Failed to update delivery partner status.",
    };
  }
};
const assignDeliveryPerson = async (payload) => {
  try {
    const response = await api.post(
      "/Order/assignDeliveryPerson",
      payload
    );

    const data = response?.data;

    if (data?.responseCode === "00") {
      return {
        success: true,
        message: data?.responseMessage || "Delivery partner assigned",
        data,
      };
    }

    return {
      success: false,
      message:
        data?.responseMessage ||
        "Failed to assign delivery partner.",
    };
  } catch (error) {
    console.error("assignDeliveryPerson error:", error);

    return {
      success: false,
      message: "Failed to assign delivery partner.",
    };
  }
};
const assignPartnerAndDispatch = async ({
  orderid,
  deliveryPersonId,
  userID,
  adminId,
}) => {
  // Step 1: Assign Delivery Partner
  const assignResult = await assignDeliveryPerson({
    userid: userID || "",
    adminId: adminId ? String(adminId) : undefined,
    orderid,
    deliveryPersonId,
  });

  if (!assignResult.success) {
    return assignResult;
  }

  // Step 2: Mark as Dispatched
  await changeCatalogOrderStatus({
    userid: userID || "",
    adminId: adminId ? String(adminId) : undefined,
    orderid,
    productid: "",
    status: "dispatched",
    time: "",
    payment: "",
  });

  return {
    success: true,
    message: assignResult.message,
  };
};



  return {
    clients,
    orders,
    loading,
    busy,
    changeAdminOrderStatus,
getOrderEvents,
changeCatalogOrderStatus,
assignDoorDashOrder,
notifyDriver,
assignDeliveryPerson,
 assignPartnerAndDispatch,



  };
}